import axios from '@api'

export default {
  saveRmr (id, form) {
    return axios.patch(`api/material/return/${id}`,form)
  },
  createRmr () {
    return axios.post(`api/material/return`)
  },
  getRmr(id, page) {
    return axios.get(`api/material/return/${id}?page=${page}`)
  },
  getRmrHeader(id) {
    return axios.get(`api/material/getrmrheader/${id}`)
  },
  getRmrList() {
    return axios.get(`api/material/return/`)
  },
  removeRmr(id) {
    return axios.delete(`api/material/return/${id}`)
  },
  getRmrItemByRmrId(id) {
    return axios.get(`api/material/return/${id}/items`)
  },
  removeRmrItemRmrId(id) {
    return axios.delete(`api/material/return/${id}/items`)
  },
  submitRmr(id, form) {
    return axios.put(`api/material/return/${id}/submit`,form)
  },
  validateFinalRefurbish(id) {
    return axios.put(`api/material/return/${id}/finalrefurbish`)
  },
  approveRmr(id, form) {
    return axios.put(`api/material/return/${id}/approve`,form)
  },
  rejectRmr(id, form) {
    return axios.put(`api/material/return/${id}/reject`,form)
  },
  withdrawRmr(id) {
    return axios.put(`api/material/return/${id}/withdraw`)
  },
  cancelRmr(id) {
    return axios.put(`api/material/return/${id}/cancel`)
  },
  getRmrItem(id) {
    return axios.get(`api/material/returnitem/${id}`)
  },
  createRmrItem (item) {
    return axios.post(`api/material/returnitem`,item)
  },
  editRmrItem(form) {
    return axios.put(`api/material/returnitem`,form)
  },
  saveRmrItem(id, form) {
    return axios.patch(`api/material/returnitem/${id}`,form)
  },
  replaceRmrItem(form) {
    return axios.put(`api/material/returnitem/replace`,form)
  },
  removeRmrItem(id) {
    return axios.delete(`api/material/returnitem/${id}`)
  },
  reviewRmrItem(id, form) {
    return axios.post(`api/material/returnitem/${id}/review`,form)
  },
  reviewRmrItemCourtesy(id, form) {
    return axios.post(`api/material/returnitem/${id}/review/courtesy`,form)
  },
  completeRmrItemCourtesy(form) {
    return axios.post(`api/material/returnitem/complete/courtesy`,form)
  },
  getAttentionByRmrId(id) {
    return axios.get(`api/material/return/${id}/attention`)
  },
  saveAttention(form) {
    return axios.post(`api/material/attention`,form)
  },
  createAttention(form) {
    return axios.post(`api/material/attention`,form)
  },
  removeAttention(id) {
    return axios.delete(`api/material/attention/${id}`)
  },
  getRmrAttachmentByRmrId(id) {
    return axios.get(`api/material/return/${id}/attachment/`)
  },
  createRmrAttachment(form) {
    return axios.post(`api/material/attachment`,form)
  },
  removeRmrAttachment(id) {
    return axios.delete(`api/material/attachment/${id}`)
  },
  searchRmr(page, json) {
    return axios.post(`api/material/searchrmr/${page}`,json)
  },
  searchRmrItem(json, page) {
    return axios.post(`api/material/searchrmritem/${page}`, json)
  },
  searchPo (page, json) {
    return axios.post(`api/material/po/search/${page}`, json)
  },
  searchItem(page, json, isGetAll) {
    return axios.post(`api/material/inventory/search/${page}?isGetAll=${isGetAll}`, json)
  },
  saveJdeItems (json) {
    return axios.post(`api/material/jdeItem/save`, json)
  },
  exportRmr(id) {
    return axios.post(`api/material/${id}/export`, null, { responseType: 'arraybuffer' })
  },
  exportPhysicalMove (id) {
    return axios.post(`api/material/${id}/export/physicalmove`, null, { responseType: 'arraybuffer' })
  },
  exportScrapSale (json) {
    return axios.post(`api/material/export/scrapsale`, json, { responseType: 'arraybuffer' })
  },
  exportInvoiceSaleScrap (json) {
    return axios.post(`api/material/export/invoicesalescrap`, json, { responseType: 'arraybuffer' })
  },
  downloadRmrTemplate(rmrId) {
    return axios.get(`api/material/download/rmrtemplate/${rmrId}`, { responseType: 'arraybuffer'})
  },
  searchRmrWarehouse(json) {
    return axios.post(`api/material/warehouse/search`, json)
  },
  downloadRmrWarehouse(jsonSelected) {
    return axios.post(`api/material/warehouse/download`, jsonSelected, { responseType: 'arraybuffer' })
  },
  getMfd(id) {
    return axios.get(`api/material/mfd/${id}`)
  },
  getMfdRelatedList(id) {
    return axios.get(`api/material/mfd/${id}/related`)
  },
  getMfdReport() {
    return axios.get(`api/material/mfd/report`)
  },
  getMfdStatusReport() {
    return axios.get(`api/material/mfd/status/report`)
  },
  createMFD(json) {
    return axios.post(`api/material/createmfd`, json)
  },
  downloadMfdAttachment(id) {
    return axios.get(`api/material/mfd/attachment/${id}/download`, { responseType: 'arraybuffer' })
  },
  downloadMfdAttachmentByMfdId(id, attachmentType) {
    return axios.get(`api/material/mfd/${id}/attachment/download/${attachmentType}`, { responseType: 'arraybuffer' })
  },
  downloadAttachmentList(json) {
    return axios.post(`api/material/download/attachmentlist`, json, { responseType: 'arraybuffer' })
  },
  downloadCleaningAttachmentList(json) {
    return axios.post(`api/material/cleaningitemlist/attachment/download`, json, { responseType: 'arraybuffer' })
  },
  getMfdItemByMfdId(id) {
    return axios.get(`api/material/mfd/${id}/items`)
  },  
  getMfdAttachmentByMfdId(id, attachmentType){
    return axios.get(`api/material/mfd/${id}/attachment/${attachmentType}`)
  },
  removeMfdAttachment(id) {
    return axios.delete(`api/material/mfd/attachment/${id}`)
  },
  removeMfdAttachmentList(json) {
    return axios.post(`api/material/mfd/attachment/removelist`, json)
  },
  exportMfd(json) {
    return axios.post(`api/material/exportmfd`, json, { responseType: 'arraybuffer'})
  },
  getAuditLog(json) {
    return axios.post(`api/material/auditlog`, json)
  },
  getMfdComment(mfdid) {
    return axios.get(`api/material/mfdcomment/${mfdid}`)
  },
  addMfdComment(json) {
    return axios.post(`api/material/mfdcomment/add`, json)
  },
  saveMfd(mfdId) {
    return axios.patch(`api/material/mfd/${mfdId}/save`)
  },
  approveMfd(mfdId) {
    return axios.patch(`api/material/mfd/${mfdId}/approve`)
  },
  reviewMfd (mfdId) {
    return axios.patch(`api/material/mfd/${mfdId}/review`)
  },
  getUserMention(searchText) {
    return axios.post(`api/material/getusermention/${searchText}`)
  },
  flagIsReadMfdCommentToUser(mfdId) {
    return axios.patch(`api/material/mfd/${mfdId}/commentuser/read`)
  },
  deleteMfdItem(mfdid, id) {
    return axios.delete(`api/material/mfd/${mfdid}/deleteitem/${id}`)
  },
  deleteMfd(mfdno) {
    return axios.delete(`api/material/mfdlist/${mfdno}/delete`)
  },
  getDoaApproval(json) {
    return axios.post(`api/material/getdoaapproval`, json)
  },
  getMfdApprovalWithListIistUser(mfdid) {
    return axios.get(`api/material/mfd/${mfdid}/approvalwithusers`)
  },
  doaApproveMfd(json) {
    return axios.post(`api/material/doaapprovemfd`, json)
  },
  saveMfdField(json) {
    return axios.post(`api/material/savemfdfield`, json)
  },
  saveMfdBuyer(json) {
    return axios.post(`api/material/savemfdbuyer`, json)
  },
  getPartnerShare(companyId) {
    return axios.get(`api/material/getpartnershare/${companyId}`)
  },
  getContractPartnerShare(companyId) {
    return axios.get(`api/material/getcontractpartnershare/${companyId}`)
  },
  getMfdPartnerShare(mfdId) {
    return axios.get(`api/material/getpartnershare/mfd/${mfdId}`)
  },
  saveMfdGrossSaleType(json) {
    return axios.post(`api/material/savemfdgrosssaletype`, json)
  },
  saveMfdGrossSaleAmount(json) {
    return axios.post(`api/material/savemfdgrosssaleamount`, json)
  },
  exportExcelMfdFinance(mfdId, json) {
    return axios.post(`api/material/exportexcelmfdfinance/${mfdId}`, json, { responseType: 'arraybuffer'})
  },
  deleteRmrItemList(json) {
    return axios.post(`api/material/deletereceivermritemlist`, json)
  },
  submitRmrItemList(rmrid, json, type) {
    return axios.post(`api/material/submitreceivermritemlist/${rmrid}?type=${type}`, json)
  },
  addReceiveDateRmrItemList(json) {
    return axios.post(`api/material/addreceivedatermritemlist`, json)
  },
  getReceiveByAndDate(rmrid) {
    return axios.get(`api/material/getreceivebyanddate/${rmrid}`)
  },
  convertMaterialType(json) {
    return axios.put(`api/material/convert/returntype`, json)
  },
  convertDisposalToContaminate(json) {
    return axios.put(`api/material/convert/contaminate`, json)
  },
  receiveDateRmr(json) {
    return axios.put(`api/material/receivedatermr`, json)
  },
  cancelReceiveRmrItem(json) {
    return axios.put(`api/material/cancelreceivermritem`, json)
  },
  copyReceiveRmrItem(json) {
    return axios.post(`api/material/copyreceivermritem`, json)
  },
  updateMfdStatus (json) {
    return axios.post(`api/material/updatemfdstatus`, json)
  },
  getBuyerInvoice () {
    return axios.get(`api/material/getbuyerinvoice`)
  },
  getDeliverDateInvoice () {
    return axios.get(`api/material/getdeliverdateinvoice`)
  },
  getMfdInvoice (invoiceId) {
    return axios.get(`api/material/getmfdinvoice/${invoiceId}`)
  },
  getMfdInvoiceItem (json, invoiceId) {
    return axios.post(`api/material/getmfdinvoiceitem/${invoiceId}`, json)
  },
  submitMfdInvoiceItem (json) {
    return axios.post(`api/material/submitmfdinvoiceitem`, json)
  },
  getInvoiceItem (invoiceId) {
    return axios.get(`api/material/getinvoiceitem/invoice/${invoiceId}`)
  },
  getInvoicePending() {
    return axios.get(`api/material/invoice/status/report`)
  },
  createMfdInvoice() {
    return axios.post(`api/material/createmfdinvoice`)
  },
  updateMfdInvoice(invoiceId, json) {
    return axios.patch(`api/material/updatemfdinvoice/${invoiceId}`, json)
  },
  getMfdAssetValue(mfdId) {
    return axios.get(`api/material/mfd/${mfdId}/assetvalue`)
  },
  updateDeliverDate(mfdId, json) {
    return axios.patch(`api/material/phy/deliverdate/${mfdId}`, json)
  },
  getInvoiceAttachmentByInvoiceId(invoiceId) {
    return axios.get(`api/material/invoice/${invoiceId}/attachment`)
  },
  downloadInvoiceAttachment(id) {
    return axios.get(`api/material/invoice/attachment/${id}/download`, { responseType: 'arraybuffer' })
  },
  downloadInvoiceAttachmentByInvoiceId(id, attachmentType) {
    return axios.get(`api/material/invoice/${id}/attachment/download`, { responseType: 'arraybuffer' })
  },
  removeInvoice(id) {
    return axios.delete(`api/material/invoice/${id}`)
  },
  removeInvoiceAttachment(id) {
    return axios.delete(`api/material/invoice/attachment/${id}`)
  },
  getMfdSummary(mfdId) {
    return axios.get(`api/material/getmfdsummary/${mfdId}`)
  },
  exportExcelMfdNonStock(json) {
    return axios.post(`api/material/exportexcelmfdnonstock`, json, { responseType: 'arraybuffer'})
  },
  getMfdInventoryWriteOffItem(mfdId) {
    return axios.get(`api/material/getmfdinventorywriteoff/${mfdId}`)
  },
  submitInventoryWriteOff(mfdId) {
    return axios.get(`api/material/submitinventorywriteoff/${mfdId}`)
  },
  MfdSearchView(json) {
    return axios.post(`api/material/search/mfd`, json)
  },
  PoSearchView(json) {
    return axios.post(`api/material/search/po`, json)
  },
  InvoiceSearchView(json) {
    return axios.post(`api/material/search/invoice`, json)
  },
  getCleaning(id) {
    return axios.get(`api/material/cleaning/${id}`)
  },
  getCleaningItemByCleaningId(id) {
    return axios.get(`api/material/cleaning/${id}/items`)
  },
  createCleaningItem(form) {
    return axios.post(`api/material/cleaningitem`, form)
  },
  removeCleaningItem(id) {
    return axios.delete(`api/material/cleaningitem/${id}`)
  },
  saveCleaning(id, form) {
    return axios.patch(`api/material/cleaning/${id}`, form)
  },
  editCleaning(form) {
    return axios.put(`api/material/cleaning`, form)
  },
  saveCleaningItem(form) {
    return axios.put(`api/material/cleaningitem`, form)
  },
  stampCleaningRmrItem(id, sumReceiveQty) {
    return axios.put(`api/material/stampcleaningrmritem/${id}/${sumReceiveQty}`)
  },
  manualReceiveCleaningItem(cleaningId) {
    return axios.put(`api/material/cleaning/${cleaningId}/receiveitem`)
  },
  getCleaningAttachment(id) {
    return axios.get(`api/material/cleaning/attachment/${id}`)
  },
  getCleaningAttachmentByCleaningId(cleaningId) {
    return axios.get(`api/material/cleaning/${cleaningId}/attachment`)
  },
  getCleaningAttachmentByMfdId(mfdId) {
    return axios.get(`api/material/cleaning/mfd/${mfdId}/attachment`)
  },
  downloadCleaningAttachment(id) {
    return axios.get(`api/material/cleaning/attachment/${id}/download`, { responseType: 'arraybuffer' })
  },
  downloadCleaningAttachmentByCleaningItemId(id, attachmentType) {
    return axios.get(`api/material/cleaningitem/${id}/attachment/download?attachmentType=${attachmentType}`, { responseType: 'arraybuffer' })
  },
  searchRmrItemWarehouse(json) {
    return axios.post(`api/material/rmritemwarehouse/search`, json)
  },
  receiveDateRmrItem(json) {
    return axios.put(`api/material/receivedatermritem`, json)
  },
  getWhHeader(rmrId, type) {
    return axios.get(`api/material/warehouseheader/${rmrId}/${type}`)
  },
  removeInvoiceItem(invoiceId) {
    return axios.delete(`api/material/delete/invoiceitem/invoice/${invoiceId}`)
  },
  updateInvoiceExchange(json) {
    return axios.put(`api/material/invoice/updateexchange/`, json)
  },
  updateRmrItem(json) {
    return axios.post(`api/material/update/rmritem/`, json)
  },
  getAllocationHistory() {
    return axios.get(`api/material/return/allocationhistory`)
  },
  exportAfeAllocation() {
    return axios.get(`api/material/export/afeallocation`, { responseType: 'arraybuffer' })
  },
  getCleaningList(json) {
    return axios.post(`api/material/getcleaning`, json);
  },
  getIssueAttachmentByCleaningId(cleaningId) {
    return axios.get(`api/material/issue/${cleaningId}/attachment`)
  },
  removeIssueAttachment(id) {
    return axios.delete(`api/material/issue/attachment/${id}`)
  },
  downloadIssueAttachment(id) {
    return axios.get(`api/material/issue/attachment/${id}/download`, { responseType: 'arraybuffer' })
  },
  searchCleaningRmrItem(json, page) {
    return axios.post(`api/material/searchcleaning/rmritem/${page}`, json)
  },
  saveCleaningIssueItem(json, cleaningId) {
    return axios.post(`api/material/cleaning/${cleaningId}/saveitem`, json)
  },
  getCleaningIssueItem(id) {
    return axios.get(`api/material/cleaning/${id}/issueitems`)
  },
  submitCleaning(json, type) {
    return axios.post(`api/material/cleaning/submit/${type}`, json)
  },
  createNewCleaning() {
    return axios.get(`api/material/cleaning/create`)
  },
  getCleaningHeader(id) {
    return axios.get(`api/material/cleaningheader/${id}`)
  },
  saveUpdateCleaningItem(json) {
    return axios.post(`api/material/saveupdate/cleaningitem`, json)
  },
  deleteCleaning(id) {
    return axios.delete(`api/material/cleaning/${id}/delete`)
  },
  deleteCleaningIssueItem(id) {
    return axios.delete(`api/material/cleaningissueitem/${id}`)
  },
  saveUpdateCleaningItemReceive(json) {
    return axios.post(`api/material/saveupdate/cleaningitem/receive`, json)
  },
  swapPendingReceive(json, type) {
    return axios.post(`api/material/swap/pendingreceive?type=${type}`, json)
  },
  downloadReceiveAttachment(id) {
    return axios.get(`api/material/receive/contaminate/attachment/${id}`, { responseType: 'arraybuffer' })
  },
  removeReceiveAttachment(id) {
    return axios.delete(`api/material/receive/contaminate/attachment/${id}`)
  },
  getReceiveContaminateAttachmentByRmrId(id) {
    return axios.get(`api/material/contaminate/${id}/attachment`)
  },
  getReviewDetail(rmrId) {
    return axios.get(`api/material/getreviewdetail/${rmrId}`)
  }
}
